import { render, staticRenderFns } from "./UserStepToStep.vue?vue&type=template&id=327174e0&scoped=true&"
import script from "./UserStepToStep.vue?vue&type=script&lang=js&"
export * from "./UserStepToStep.vue?vue&type=script&lang=js&"
import style0 from "./UserStepToStep.vue?vue&type=style&index=0&id=327174e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327174e0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DashboardCard: require('/workspace/components/Dashboard/DashboardCard.vue').default})
